module.exports = __webpack_public_path__ + "static/M.HardianBasukiMD-d5f5a3e2007f291f611408f8457d2777.jpg";